import moment from "moment/moment";
import Config from "../Config";


export const duesLabelMapping = {
    [Config.DUES_TYPES.RENT]: "Rent",
    [Config.DUES_TYPES.SECURITY]: "Security",
    [Config.DUES_TYPES.MAINTENANCE]: "Maintenance",
    [Config.DUES_TYPES.ELECTRICITY]: "Electricity",
    [Config.DUES_TYPES.REGISTRATION]: "Registration",
    [Config.DUES_TYPES.TECH_CHARGES]: "Technical Charges",
    [Config.DUES_TYPES.OTHER]: "Other",
    [Config.DUES_TYPES.AGREEMENT_CHARGE]: "Agreement Charges",
    [Config.DUES_TYPES.FOOD]: "Food",
    [Config.DUES_TYPES.FINE]: "Fine",
    [Config.DUES_TYPES.SETTLEMENT]: "Settlement",
    [Config.DUES_TYPES.WIFI]: "Wifi",
    [Config.DUES_TYPES.GAS]: "Gas",
    [Config.DUES_TYPES.MAID_CHARGES]: "Maid Charges",
    [Config.DUES_TYPES.DAMAGE]: "Damage",
    [Config.DUES_TYPES.KEY_CHARGES]: "Key Charges",
    [Config.DUES_TYPES.LAUNDRY_CHARGES]: "Laundry Charges",
    [Config.DUES_TYPES.MOVE_OUT_CHARGES]: "MoveOut Charges",
    [Config.DUES_TYPES.GUEST_CHARGES]: "Guest Charges",
};

export const formatDateRange = (due) => {
    if (due.type === Config.DUES_TYPES.SECURITY) {
        return "Initial security deposit";
    } else if (due.rentStartDate && due.rentEndDate) {
        return `${moment(due.rentStartDate).format("DD MMM YY")} - ${moment(due.rentEndDate).format("DD MMM YY")}`;
    } else if (due.dueDate) {
        return `For ${moment(due.dueDate).format("MMM YY")}`;
    }
    return "";
};